module.exports = __webpack_public_path__ + "images/NFL_DC_Logo-4bd5ca4643651191c003d225b1501c2c.svg";